import React from 'react'
import styles from './MainTitle.module.css'

class MainTitle extends React.Component {
  render () {
    return (
      <div className={styles.mainTitleContainer}>
        <h2>Hydraulický výpočet pro návrh kanalizačního potrubí</h2>
        <h3>Výpočet průtoku a rychlosti v kruhovém profilu s volnou hladinou dle rovnice Colebrook-White</h3>  
      </div>
    )
  }
}

export default MainTitle
